import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import ExpandableContent from 'Component/ExpandableContent';
import Icon from 'Component/Icon';
import Link from "Component/Link";
import { history } from 'Util/History';

import './CategoryTree.style';

/** @namespace AdvoxBasic/Component/CategoryTree/Component/CategoryTreeComponent */
export class CategoryTreeComponent extends PureComponent {
    static propTypes = {
        category: PropTypes.object.isRequired,
        hasParentCategory: PropTypes.bool,
        parentCategory: PropTypes.object,
    };

    static defaultProps = {
        hasParentCategory: false,
    };

    goToCategory = (url) => {
        const { hideActiveOverlay } = this.props;

        history.push(url);
        hideActiveOverlay();
    };

    renderBackButton() {
        const { parentCategory, hasParentCategory } = this.props;

        if (!hasParentCategory) {
            return null;
        }

        return (
            <div block="CategoryTree" elem="BackButton">
                <Link
                    mix={{
                        block: 'CategoryTree',
                        elem: 'Button',
                    }}
                    to={parentCategory.category_url}
                >
                    <Icon name="small_arrow_left" />
                    {parentCategory.category_name}
                </Link>
            </div>
        );
    }

    renderChildren() {
        const { category, hasParentCategory } = this.props;

        if (!category.children) {
            return null;
        }

        return (
            <ul block="CategoryTree" elem="Categories" mods={{ hasParentCategory }}>
                {category.children.map(({ id, name, url }) => (
                    <li key={id}>
                        <Link
                            block="CategoryTree"
                            elem="Category"
                            mix={{
                                block: 'CategoryTree',
                                elem: 'Button',
                            }}
                            to={url}
                        >
                            {name}
                        </Link>
                    </li>
                ))}
            </ul>
        );
    }

    render() {
        const { category, heading, hasParentCategory } = this.props || {};

        if (!hasParentCategory && !category?.children?.length) {
            return null;
        }

        return (
            <ExpandableContent heading={heading} mix={{ block: 'CategoryTree' }} isArrow isContentExpanded>
                {this.renderBackButton()}
                {category?.children?.length ? this.renderChildren() : null}
            </ExpandableContent>
        );
    }
}

export default CategoryTreeComponent;
